export const ru = {
    'no-rights': 'Недостаточно прав для применения рекомендации',
    'platform-accept-button': 'Разрешить',
    'platform-accept-progress-button': 'Разрешаем',
    'switch-on-autotargeting-button': 'Включить',
    'switch-on-autotargeting-progress-button': 'Включаем'
};
